import { createAction } from 'typesafe-actions';

import { EAdvancedFilterType } from 'shared/enums/EAdvancedFilterType';

export const validateFloorFilterAction = createAction('filters/validateFloorFilter')<
  EAdvancedFilterType.floor | EAdvancedFilterType.floorn
>();
